/**
 * @创建人: 袁俊双
 * @修改人: 袁俊双
 * @描述: 组合查询
 * @创建时间: 20120-07-24
 * @修改时间: 20120-07-24
 */

import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';

@Component({
  selector: 'sw-concat-query',
  templateUrl: './sw-concat-query.component.html',
  styleUrls: ['./sw-concat-query.component.css']
})
export class SwConcatQueryComponent implements OnInit {

  constructor(
    private box: SwMassageBoxService,
  ) { }

  /**
   * 输入搜索栏数据 
   * 
   * 参数类型:[{
   *          isMuitl:false,  //该条件是否允许多选
   *          showMore:false, 
   *          title:'搜索栏名称',
   *          code:'字段名称',
   *          tags: [ {id:'显示一栏的数据id',text:'显示一栏的数据text'}] 
   *          } ] 
   */
  @Input() sortList: Array<any> = [];

  /**
   * 查询框绑定的数据 ：在使用选中栏的时候 能个查询框的数据绑定 { key : value }
   */
  @Input() formValue: any = {}

  /**
   * 查询栏收起的时候展示的查询栏数量，默认 3 栏， 注意，此数量不能大于 sortList.length ,否则所有栏
   */
  @Input() defaultNum: number = 3

  /**
   * 查询栏所有已筛选条件的最大数量，默认不做限制
   */
  @Input() maxSelectNum: number = 0

  /**
   * 1.该属性值发生变化时，将选中数据全部清空，比如数字资源的面包屑查询时，不需要携带此组件内部的查询条件，就要将查询区域条件清空，此时查询已经完成，只需要再清空选中样式就好
   * 2.与重置功能的区别是， 重置功能是组件内部实现的清空，重置后会抛出重置后的查询条件， 此属性实现的清空只是把选中条件样式清空，但是不会抛出
   * 3.传入的此值最好使用随机数，例如 new Date().getTime()
   */
  @Input() isClearAllSelected: any;

  /**
   * 是否主动抛出此时的查询条件对象，用于组件外部在不惦记查询按钮时想使用此组件的查询条件的情况， 比如数字资源-资源检索的全文检索页需要此组件的查询条件
   * 传入的此值最好使用随机数，例如 new Date().getTime()
   */
  @Input() isVotedSelected: any;
  
  /**
   * 当输入属性 isVotedSelected 改变时，主动抛出此时的查询条件对象
   */
  @Output() votedSelected = new EventEmitter;
  
  /**
   * 点击查询 按钮事件发射 eg:[{code：'' ,value:''}]
   */
  @Output() onSelect = new EventEmitter;
  
  /**
   * 重置 点击重置按钮事件抛出 eg:[{code：'' ,value:''}]
   */
  @Output() onReset = new EventEmitter();

  /**
   * 表单查询是否展示 默认展示
   * @ignore
   */
  isFormBoxShow: boolean = false;

  /**
   * 已选中的分类条件
   * @ignore
   */
  selectedTags = [];

  /**
   *查询条件，包括分类查询与表单查询（键值对）
    * @ignore
    */
  conditions: any = {};

  /**
   *已经选中的标签的高亮样式的键值对
    * @ignore
    */
  checkedModel: any = {};

  /**
   *全局搜索文本
   * @ignore
   */
  searchValue:string

  /**
 * @ignore
 */
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //如果中途需要外部主动将选中数据全部清空，比如数字资源的面包屑查询时，就要将查询区域条件清空
    if(changes.isClearAllSelected && changes.isClearAllSelected.currentValue){
      //只有当changes.isClearAllSelected.currentValue 有值的时候才会执行，清空选中, 清空之后就不抛出了,因为是外部主动清除的,接下来要做什么操作业务自己处理
      //将已选中的条件全部清空，这里只能清空已选中的查询栏标签，查询表单要直接在外部父组件清空
      this.selectedTags = []
      //将所有的高亮样式取消
      for (const key in this.checkedModel) {
        this.checkedModel[key] = false
      }
      //将全局搜索条件清空
      this.searchValue = ""
    }
    if(changes.isVotedSelected && changes.isVotedSelected.currentValue){
      //只有当changes.isVotedSelected.currentValue 有值的时候才会执行，抛出已有的查询条件
      this.tranf(this.formValue)
      this.votedSelected.emit(this.conditions)
    }
    if(changes.sortList){
      if(this.sortList.length && this.defaultNum > this.sortList.length){
        this.defaultNum = this.sortList.length
      }
    }
    
  }

  ngAfterViewInit(): void {
  }
  
  /**
   * 显示隐藏查询框
   * @ignore
   */
  toggleBtn() {
    this.isFormBoxShow = !this.isFormBoxShow;
  }

  /**
   * 分类查询标签点击时选中，将已选中的项添加到已选中数组selectedTags中
   * @ignore
   * @param item 行的code 
   * @param val  选中的数据
    */
  onTagClick(item, val,event?) {
    if(item.isMuitl && item['checkbox']){
      //如果是可多选的，且多选框已经出来了
      if(event.target.checked){
        //如果是勾选多选框的操作
        //先看是否在选中的数组中了
        let select = this.selectedTags.find(x => x.typeCode == item.code && x.id == val.id);
        if (select) {
          //如果点击的标签已经选中过，就什么都不做
        } else {
          //如果有选中标签个数限制，那么在新增的时候，超过个数就不能新增了
          if(this.maxSelectNum && this.selectedTags.length >= this.maxSelectNum){
            this.box.danger('已达到最大选中数')
            //将该标签的高亮样式取消
            delete this.checkedModel[item.code+'-'+ val.id]
            event.target.checked = false
            return
          }
          //如果点击的标签不在已选中数组中，就加入
          this.selectedTags.push({ typeCode: item.code, id: val.id, text: val.text, title:item.title })
          //然后修改其样式
          this.checkedModel[item.code+'-'+val.id] = true
        }
      } else {
        //如果是取消勾选的操作，就从已经选中的数组中删掉
        this.selectedTags.splice(this.selectedTags.findIndex(x => x.typeCode == item.code && x.id == val.id), 1)
        //找到原来选中的标签，将它的高亮样式取消
        this.checkedModel[item.code+'-'+ val.id] = false
      }
    } else if(!item.isMuitl || item.isMuitl && !item['checkbox']){
      //如果该项是单选，或是可多选但是没有出现复选框，就还是单选。那么该分类只能选中一个标签，如果该分类已经有选中的标签了，就替换
      if (this.selectedTags.length > 0) {
        let select = this.selectedTags.find(x => x.typeCode == item.code);
        if(select){
          //找到原来选中的标签，将它的高亮样式取消
          this.checkedModel[item.code+'-'+ select.id] = false
          //如果已选中数组中已经存在这个类别的标签，就替换
          select.id = val.id;
          select.text = val.text;
          //将新选中的改为高亮样式
          this.checkedModel[item.code+'-'+val.id] = true
        } else{
          //如果有选中标签个数限制，那么在新增的时候，超过个数就不能新增了
          if(this.maxSelectNum && this.selectedTags.length >= this.maxSelectNum){
            this.box.danger('已达到最大选中数')
            //将该标签的高亮样式取消
             delete this.checkedModel[item.code+'-'+ val.id]
            return 
          }
          //如果之前没有选中过该类型，就直接添加，将选中的标签放进已选中标签数组
          this.selectedTags.push({ typeCode: item.code, id: val.id, text: val.text, title:item.title })
          //然后修改其样式
          this.checkedModel[item.code+'-'+val.id] = true
        }
      } else {
        //如果有选中标签个数限制，那么在新增的时候，超过个数就不能新增了
        if(this.maxSelectNum && this.selectedTags.length >= this.maxSelectNum){
          this.box.danger('已达到最大选中数')
          //将该标签的高亮样式取消
          delete this.checkedModel[item.code+'-'+ val.id]
          return
        }
        //将选中的标签放进已选中标签数组
        this.selectedTags.push({ typeCode: item.code, id: val.id, text: val.text, title:item.title })
        //然后修改其样式
        this.checkedModel[item.code+'-'+val.id] = true
      }

    }
    // 每次点击标签也要实时抛出
    this.tranf(this.formValue)
    this.onSelect.emit(this.conditions);
  }

  /**
   * 清除已选中的单个分类项
   *  @ignore
   * @memberof SwSortQueryComponent
   */
  clearOneTag(tag) {
    this.selectedTags.splice(this.selectedTags.findIndex(x => x.typeCode == tag.typeCode && x.id == tag.id),1)
    //找到原来选中的标签，将它的高亮样式取消
    this.checkedModel[tag.typeCode+'-'+ tag.id] = false
    
    // 每次点击标签也要实时抛出
    this.tranf(this.formValue)
    this.onSelect.emit(this.conditions);
  }

  /**
   * 清除所有已选中的分类项
   *  @ignore
   * @memberof SwSortQueryComponent
   */
  clearAllTags() {
    this.selectedTags = [];
    //将所有的高亮样式取消
    for (const key in this.checkedModel) {
      this.checkedModel[key] = false
    }
    // 每次点击标签也要实时抛出
    this.tranf(this.formValue)
    this.onSelect.emit(this.conditions);
  }

  /**
   * 点击多选，出现多选框，从单选变为多选框的时候，该类别已经选中的还是继续选中
   *  @ignore
   * @memberof SwSortQueryComponent
   */
  clickMuitl(item){
    item['checkbox'] = true
  }

  /**
   * 点击取消多选，多选框消失，从多选框变为单选的时候，该类别已经选中的要全部取消选中
   *  @ignore
   * @memberof SwSortQueryComponent
   */
  clickCancelMuitl(item){
    item['checkbox'] = false
    //在已经选中的标签数组中筛选出该类别的标签 
    let selecteds = this.selectedTags.filter(v=>v.typeCode == item.code)
    if(selecteds && selecteds.length){
      selecteds.forEach(select=>{
        //如果有，就从已选中数组中删除
        this.selectedTags.splice(this.selectedTags.findIndex(x => x.typeCode == item.code && x.id == select.id), 1)
        //找到原来选中的标签，将它的高亮样式取消
        this.checkedModel[item.code+'-'+ select.id] = false
      })
      
    }
  }

  /**
   * 点击更多，出现其他更多选项
   *  @ignore
   * @memberof SwSortQueryComponent
   */
  clickMore(item){
    item.showMore = true
  }

  /**
   * 点击收起
   *  @ignore
   * @memberof SwSortQueryComponent
   */
  clickCancelMore(item){
    item.showMore = false
  }

  /**
   * 查询事件
   *  @ignore
   * @memberof SwSortQueryComponent
   */
  clickSelect() {
    this.tranf(this.formValue)
    this.onSelect.emit(this.conditions);
  }

  /**
   * 点击重置
   *  @ignore
   * @memberof SwSortQueryComponent
   */
  reset(){
    //将已选中的条件全部清空
    this.selectedTags = []
    //将所有的高亮样式取消
    for (const key in this.checkedModel) {
      this.checkedModel[key] = false
    }
    // 将全局搜索清空
    this.searchValue = ""
    this.tranf({})
    this.onReset.emit(this.conditions);
  }

  /**
   * 
   * 将被选中的分类条件数组转换为可供查询的键值对形式，并组合形成新的综合分类与表单组合查询条件
   * @memberof SwSortQueryComponent
   * @ignore
   */
  tranf(formValue) {
    // 遍历对象，如果对象中值不存在，就将此值删除，避免 没有有效值 还覆盖了 搜索栏 重复的查询条件
    for (const key in formValue) {
      if (formValue[key] == undefined || formValue[key] == null) {
        // 如果表单查询中的值是undefined或者是null，就将这个键值对从对象中删除
        delete formValue[key]
      }
    }
    this.conditions = {}
    this.selectedTags.forEach(item => {
      if(!this.conditions[item.typeCode]){
        //如果该类型还没有值，就直接赋值
        this.conditions[item.typeCode] = item.id
      } else {
        this.conditions[item.typeCode] = this.conditions[item.typeCode] + ',' + item.id
      }
    })
    // 将搜索栏条件和表单搜索条件合并成一个对象并抛出
    this.conditions = { ...this.conditions, ...formValue };
    // 再加上全局搜索条件
    if(this.searchValue){
      this.conditions['searchValue'] = this.searchValue
    }
  }


}
